import { c as _c } from "react/compiler-runtime";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
import DateCountdown from "../date-countdown/DateCountdown";
import styles from "./MintCountdownBox.module.scss";
interface Props {
  mintInfo?: {
    title: string;
    date: number; // Unix seconds
    showAllowlistInfo?: boolean;
    isFinalized?: boolean;
    isEnded?: boolean;
    isSoldOut?: boolean;
  };
  linkInfo?: {
    href: string;
    target: "_blank" | "_self";
  };
  hideMintBtn?: boolean;
  small?: boolean;
}
export default function MintCountdownBox(props) {
  const $ = _c(33);
  const {
    mintInfo,
    linkInfo,
    hideMintBtn,
    small
  } = props;
  const hasMintInfo = Boolean(mintInfo);
  const canShowMintButton = !small && !hideMintBtn && hasMintInfo && Boolean(linkInfo);
  const showSkeletonButton = !hasMintInfo;
  let t0;
  if ($[0] !== mintInfo) {
    t0 = mintInfo?.date === null || mintInfo?.date === undefined ? undefined : new Date(mintInfo.date * 1000);
    $[0] = mintInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const countdownDate = t0;
  const showAllowlistInfo = mintInfo?.showAllowlistInfo;
  const t1 = small ? styles.countdownContainerShort : "";
  let t2;
  if ($[2] !== t1) {
    t2 = [styles.countdownContainer, t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const containerClasses = t2.join(" ");
  if (mintInfo?.isSoldOut) {
    let t3;
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h4 className="mb-3">✅ Mint Complete - Sold Out!</h4>;
      t4 = <p className="mb-1 tw-font-medium">All NFTs have been successfully minted.</p>;
      t5 = <p className="mb-0 tw-text-md">Thank you for participating!</p>;
      $[4] = t3;
      $[5] = t4;
      $[6] = t5;
    } else {
      t3 = $[4];
      t4 = $[5];
      t5 = $[6];
    }
    let t6;
    if ($[7] !== containerClasses) {
      t6 = <div className={containerClasses}>{t3}{t4}{t5}</div>;
      $[7] = containerClasses;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  }
  if (mintInfo?.isFinalized) {
    let t3;
    let t4;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h4 className="mb-3">⌛️ Mint Phase Complete</h4>;
      t4 = <p className="mb-1 tw-font-medium">This mint phase has ended.</p>;
      t5 = <p className="mb-0 tw-text-md">Thank you for participating!</p>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t3 = $[9];
      t4 = $[10];
      t5 = $[11];
    }
    let t6;
    if ($[12] !== containerClasses) {
      t6 = <div className={containerClasses}>{t3}{t4}{t5}</div>;
      $[12] = containerClasses;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t3;
  if ($[14] !== showAllowlistInfo) {
    t3 = showAllowlistInfo && <><FontAwesomeIcon icon={faInfoCircle} data-tooltip-id="allowlist-info" data-tooltip-content="The timer displays the current time remaining for a specific phase of the drop. Please refer to the distribution plan to check if you are in the allowlist." className={styles.allowlistInfo} /><Tooltip id="allowlist-info" place="left" opacity={1} border="1px solid rgba(255, 255, 255, 0.15)" style={{
        backgroundColor: "#37373E",
        color: "white",
        padding: "10px 14px",
        maxWidth: "250px",
        fontSize: "14px",
        lineHeight: "1.4",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
        borderRadius: "6px"
      }} /></>;
    $[14] = showAllowlistInfo;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const t4 = `pt-2 pb-2 tw-w-full ${!canShowMintButton && "text-center"}`;
  const t5 = mintInfo?.title;
  let t6;
  if ($[16] !== countdownDate || $[17] !== t5) {
    t6 = <DateCountdown title={t5} date={countdownDate} />;
    $[16] = countdownDate;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== showSkeletonButton) {
    t8 = showSkeletonButton && <div className="pt-2 pb-2 tw-w-full"><button disabled={true} className={`pt-2 pb-2 btn-block no-wrap ${styles.mintBtn} ${styles.skeletonBtn}`}> </button></div>;
    $[22] = showSkeletonButton;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== canShowMintButton || $[25] !== linkInfo) {
    t9 = canShowMintButton && linkInfo && <div className="pt-2 pb-2 tw-w-full"><Link href={linkInfo.href} target={linkInfo.target} rel={linkInfo.target === "_blank" ? "noopener noreferrer" : undefined}><button className={`pt-2 pb-2 btn-block no-wrap ${styles.mintBtn}`}>Mint</button></Link></div>;
    $[24] = canShowMintButton;
    $[25] = linkInfo;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== containerClasses || $[28] !== t3 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t10 = <div className={containerClasses}>{t3}{t7}{t8}{t9}</div>;
    $[27] = containerClasses;
    $[28] = t3;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
}